const {randomId} = require("@Common/utils/random");

module.exports = (() => {
    const sample = ({defaultSlot, printUrl}) => ({
        "dateCreated":"2022-09-08T22:08:01-05:00",
        "dateModified":"2022-09-08T22:08:01-05:00",
        "name":"AA",
        "fileType":"png",
        "fileSize":63934,
        // "thumbnailUrl":"https:\/\/assets.awsdev.xpressdocs.com\/dserv\/p\/3\/29409515.png",
        "thumbnailUrl":printUrl,
        // "thumbnailUrl":require("./aa.png"),
        "width":697,
        "height":763,
        "quality":"Medium",
        defaultSlot,
        // "printUrl":"https:\/\/assets.awsdev.xpressdocs.com\/pictures\/headshot\/2022\/09\/08\/5\/29409515o.png",
        "printUrl":printUrl,
        // "printUrl":require("./aa.png"),
        // "printUrl":require("./Transparent_PNG_high.png"),
        // "printUrl":require("./4d2573613020f2d11b0f662a55a2c3a0.jpeg"),
        "id":randomId(),
    });
    return [
        sample({
            // defaultSlot: 0,
            printUrl: "https://picsum.photos/seed/k2ws1/200/300",
        }),
        sample({
            defaultSlot: 1,
            printUrl: "https://picsum.photos/seed/32534/300/200",
        }),
        // sample({
        //     defaultSlot: 2,
        //     printUrl: "https://picsum.photos/seed/535de/300/200",
        // }),
        // sample({
        //     // defaultSlot: 0,
        //     printUrl: "https://picsum.photos/seed/3516/200/300",
        // }),
        // sample({
        //     // defaultSlot: 0,
        //     printUrl: "https://picsum.photos/seed/63tg/200/300",
        // }),
        // sample({
        //     // defaultSlot: 0,
        //     printUrl: "https://picsum.photos/seed/y54g/200/300",
        // }),
    ]
        .map((_, i) => ({
            ..._,
            name: "AAA-" + (i+1),
        }))
    ;
})();
// module.exports = [
//     {
//         "dateCreated":"2022-09-08T22:08:01-05:00",
//         "dateModified":"2022-09-08T22:08:01-05:00",
//         "name":"AA",
//         "fileType":"png",
//         "fileSize":63934,
//         // "thumbnailUrl":"https:\/\/assets.awsdev.xpressdocs.com\/dserv\/p\/3\/29409515.png",
//         "thumbnailUrl":"https://picsum.photos/seed/k2ws1/200/300",
//         // "thumbnailUrl":require("./aa.png"),
//         "width":697,
//         "height":763,
//         "quality":"Medium",
//         "defaultSlot":1,
//         // "printUrl":"https:\/\/assets.awsdev.xpressdocs.com\/pictures\/headshot\/2022\/09\/08\/5\/29409515o.png",
//         "printUrl":"https://picsum.photos/seed/k2ws1/200/300",
//         // "printUrl":require("./aa.png"),
//         // "printUrl":require("./Transparent_PNG_high.png"),
//         // "printUrl":require("./4d2573613020f2d11b0f662a55a2c3a0.jpeg"),
//         "id":29409515,
//     },
//     {
//         "dateCreated":"2022-09-08T22:08:01-05:00",
//         "dateModified":"2022-09-08T22:08:01-05:00",
//         "name":"BB",
//         "fileType":"png",
//         "fileSize":63934,
//         // "thumbnailUrl":"https:\/\/assets.awsdev.xpressdocs.com\/dserv\/p\/3\/29409515.png",
//         "thumbnailUrl":"https://picsum.photos/seed/7574/200/300",
//         // "thumbnailUrl":require("./aa.png"),
//         "width":697,
//         "height":763,
//         "quality":"Medium",
//         "defaultSlot":0,
//         // "printUrl":"https:\/\/assets.awsdev.xpressdocs.com\/pictures\/headshot\/2022\/09\/08\/5\/29409515o.png",
//         "printUrl":"https://picsum.photos/seed/7574/200/300",
//         // "printUrl":require("./aa.png"),
//         // "printUrl":require("./Transparent_PNG_high.png"),
//         // "printUrl":require("./4d2573613020f2d11b0f662a55a2c3a0.jpeg"),
//         "id":345374,
//     },
// ];